import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import MarkdownToHtml from '../MarkdownToHtml';

const classes = {
  success: 'text-green-600',
  successBlue: 'text-blue-500',
  danger: 'text-red-600',
  default: 'text-gray-600',
  warning: 'text-orange-600',
  theme: 'text-theme',
  themeWithBg: 'text-theme bg-theme bg-opacity-25 px-2 py-1 font-bold text-sm rounded-lg',
};

const getClasses = (level, italic, inline, capitalize, className) => clsx(
  classes[level],
  italic && 'italic',
  'font-normal',
  inline && 'inline',
  capitalize && 'capitalize',
  className,
);

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    maxWidth: '350px',
  },
  arrow: {
    color: theme.palette.common.white,
  },
}))(Tooltip);

const Label = ({
  text, icon, level, italic, inline, doShow, descriptionOnHover, tooltipPlacement, capitalize,
  className,
}) => {
  if (!doShow) return (<></>);

  const renderLabelContent = (
    <div className={clsx(getClasses(level, italic, inline, capitalize, className), { 'leading-4 flex gap-1': icon })}>
      {icon && React.cloneElement(icon, { className: `inline-block ${(icon.props && icon.props.className) || ''}` })}
      <span className={clsx({ 'align-middle': icon })}>{text}</span>
    </div>
  );

  if (descriptionOnHover) {
    return (
      <LightTooltip
        title={typeof descriptionOnHover === 'string' ? <MarkdownToHtml content={descriptionOnHover} className="text-xs font-normal text-black" /> : descriptionOnHover}
        placement={tooltipPlacement}
        arrow
      >
        {renderLabelContent}
      </LightTooltip>
    );
  }
  return renderLabelContent;
};

Label.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.node,
  level: PropTypes.string,
  italic: PropTypes.bool,
  inline: PropTypes.bool,
  doShow: PropTypes.bool,
  capitalize: PropTypes.bool,
  descriptionOnHover: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltipPlacement: PropTypes.string,
  className: PropTypes.string,
};

Label.defaultProps = {
  text: '',
  level: 'default',
  italic: false,
  inline: false,
  icon: undefined,
  doShow: true,
  capitalize: false,
  descriptionOnHover: undefined,
  tooltipPlacement: undefined,
  className: '',
};

export default Label;
